(function() {
	'use strict';

	angular.module('quantixApp').factory('RatedBankerService',
			RatedBankerService);

	RatedBankerService.$inject = [ '$resource', '$q', '$http' ];

	function RatedBankerService($resource, $q, $http) {
	
	
		//added for getting banker list
		var _getBankerNamesList = function() {
			var deferred = $q.defer();
			var url = 'api/ratedBanker/getBankerList';

			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getBankerCode = function() {
			var deferred = $q.defer();
			var url = 'api/ratedBanker/getBankerCode';

			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getBankerDetails = function(inputData){
			var deferred = $q.defer();
			var url = 'api/ratedBanker/getBankerDetails';

			$http.post(url,inputData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		
			
		}
		
		var _getRatedBankerSearch = function(searchText, bankerCode) {

			var deferred = $q.defer();

			var url = 'api/ratedBanker/getSearchCompanyForRated';

			$http.get(url, {
				params : {
					searchText : searchText,
					bankerCode : bankerCode
				},
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _addAllToPortfolio = function(inputData){
			var deferred = $q.defer();
			var url = 'api/ratedBanker/addAllToPortfolio';

			$http.post(url,inputData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		
			
		}
		
		return {
			
			getBankerNamesList : _getBankerNamesList,
			getBankerCode : _getBankerCode,
			getBankerDetails : _getBankerDetails,
			getRatedBankerSearch : _getRatedBankerSearch,
			addAllToPortfolio : _addAllToPortfolio
		}
	
	}
	
	
	
	})();